import { RouteObject } from "react-router-dom";
import ServiceFormListPage from "modules/service-portal/form-builder/pages/ServiceFormListPage";
import ServiceFormBuilderPage from "modules/service-portal/form-builder/pages/ServiceFormBuilderPage";

const SERVICE_PORTAL_ROUTES: RouteObject[] = [
    {
        path: "service-builder",
        element: <ServiceFormListPage />,
    },
    {
        path: "service-builder/new",
        element: <ServiceFormBuilderPage />,
    },
    {
        path: "service-builder/:formId",
        element: <ServiceFormBuilderPage />,
    },
];

export default SERVICE_PORTAL_ROUTES;
